import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material"
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Slide,
  Typography,
  Zoom,
} from "@mui/material"
import { useContext, useEffect, useState } from "react"
import image1 from "../../../assets/onboarding/1.png"
import image2 from "../../../assets/onboarding/2.png"
import image3 from "../../../assets/onboarding/3.png"
import image4 from "../../../assets/onboarding/4.png"
import image5 from "../../../assets/onboarding/5.png"
import image6 from "../../../assets/onboarding/6.png"
import image7 from "../../../assets/onboarding/7.png"
import { customPalette } from "../../../theme"
import { UserContext } from "../../core/context/user/user-context"
import { useUser } from "../../core/hooks/use-user"

const steps = [
  { image: image1 },
  { image: image2 },
  { image: image3 },
  { image: image4 },
  { image: image5 },
  { image: image6 },
  { image: image7 },
]

export function FeatureTourModal(): React.JSX.Element {
  const { user, isFromLogoutButton, setShowNewFeatures, showNewFeatures } = useContext(UserContext)

  const { changeDontShowNewFeatures } = useUser()

  const [activeStep, setActiveStep] = useState(0)
  const [dontShowAgain, setDontShowAgain] = useState(false)
  const [loading, setLoading] = useState(true)
  const [direction, setDirection] = useState<"left" | "right">("left")
  const [slideKey, setSlideKey] = useState(0)

  useEffect(() => {
    if (user?.showNewFeatures && !isFromLogoutButton) {
      setShowNewFeatures(true)
    }
  }, [isFromLogoutButton, setShowNewFeatures, user?.showNewFeatures])

  function handleClose(): void {
    if (dontShowAgain && user?.cognitoUserId) {
      changeDontShowNewFeatures(user?.cognitoUserId)
    }
    setShowNewFeatures(false)
    setActiveStep(0)
  }

  function handleNext(): void {
    if (activeStep < steps.length - 1) {
      setDirection("left")
      setActiveStep((prev) => prev + 1)
      setSlideKey((prev) => prev + 1)
      setLoading(true)
    }
  }

  function handleBack(): void {
    if (activeStep > 0) {
      setDirection("right")
      setActiveStep((prev) => prev - 1)
      setSlideKey((prev) => prev + 1)
      setLoading(true)
    }
  }

  const { image } = steps[activeStep]

  return (
    <Dialog
      open={showNewFeatures}
      onClose={handleClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{ sx: { borderRadius: 4, p: 0, background: customPalette.dark1 } }}
      TransitionComponent={Zoom}>
      <DialogContent
        sx={{
          height: 650,
          p: 0,
          position: "relative",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}>
        {loading && (
          <CircularProgress
            sx={{
              position: "absolute",
              zIndex: 2,
            }}
          />
        )}

        <Slide key={slideKey} direction={direction === "left" ? "left" : "right"} in={!loading} timeout={500}>
          <Box
            component="img"
            src={image}
            alt={`Étape ${activeStep + 1}`}
            onLoad={() => setLoading(false)}
            sx={{
              width: "100%",
              height: "110%",
              objectFit: "contain",
              position: "absolute",
              border: 4,
              overflow: "hidden",
            }}
          />
        </Slide>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2, pt: 2, overflow: "hidden" }}>
        {user?.showNewFeatures && (
          <FormControlLabel
            control={<Checkbox checked={dontShowAgain} onChange={(e) => setDontShowAgain(e.target.checked)} />}
            label="Ne plus afficher"
            sx={{ color: "white" }}
          />
        )}

        <Box sx={{ flexGrow: 1 }} />

        <Button
          onClick={handleBack}
          disabled={activeStep === 0}
          startIcon={<KeyboardArrowLeft sx={{ color: customPalette.white }} />}>
          <Typography color="white">Précédent</Typography>
        </Button>

        {activeStep === steps.length - 1 ? (
          <Button variant="contained" onClick={handleClose}>
            <Typography color={customPalette.dark1}>C'est parti !</Typography>
          </Button>
        ) : (
          <Button
            variant="contained"
            onClick={handleNext}
            endIcon={<KeyboardArrowRight sx={{ color: customPalette.dark1 }} />}>
            <Typography>Suivant</Typography>
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}
